export const isProd = () => {
  return process.env.REACT_APP_API_URL === "https://api.brandification.com/api/v1";
};
